export default "__VITE_ASSET__Cg0_zxL3__"